import { Typography } from '@mui/material'
import cx from 'classnames'
import React from 'react'

type Props = { title: string; className?: string }

const PageTitleView = (props: Props) => (
  <Typography
    className={cx(
      'pb-3 sm:pb-5 uppercase tracking-[0.5rem] sm:tracking-[0.75rem] text-center text-2xl leading-7 sm:text-4xl font-work',
      props.className
    )}
    variant="h1">
    {props.title}
  </Typography>
)

export default PageTitleView
